var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useStyleRegister } from '@ant-design/cssinjs';
import { merge } from '@formily/shared';
import { useConfig, useToken } from './hooks';
export var genCommonStyle = function (token, componentPrefixCls) {
    var _a, _b;
    var fontFamily = token.fontFamily, fontSize = token.fontSize;
    var rootPrefixSelector = "[class^=\"".concat(componentPrefixCls, "\"], [class*=\" ").concat(componentPrefixCls, "\"]");
    return _a = {},
        _a[rootPrefixSelector] = (_b = {
                fontFamily: fontFamily,
                fontSize: fontSize,
                boxSizing: 'border-box',
                '&::before, &::after': {
                    boxSizing: 'border-box',
                }
            },
            _b[rootPrefixSelector] = {
                boxSizing: 'border-box',
                '&::before, &::after': {
                    boxSizing: 'border-box',
                },
            },
            _b),
        _a;
};
export var genStyleHook = function (component, styleFn) {
    return function (prefixCls) {
        var _a = useToken(), theme = _a.theme, token = _a.token, hashId = _a.hashId;
        var _b = useConfig(), getPrefixCls = _b.getPrefixCls, iconPrefixCls = _b.iconPrefixCls;
        var rootPrefixCls = getPrefixCls();
        return [
            useStyleRegister({
                theme: theme,
                token: token,
                hashId: hashId,
                path: ['formily-antd', component, prefixCls, iconPrefixCls],
            }, function () {
                var componentCls = ".".concat(prefixCls);
                var mergedToken = merge(token, __assign(__assign({}, token['Form']), { // Merge the antd form token
                    componentCls: componentCls, prefixCls: prefixCls, iconCls: ".".concat(iconPrefixCls), antCls: ".".concat(rootPrefixCls) }));
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls,
                });
                return [genCommonStyle(token, prefixCls), styleInterpolation];
            }),
            hashId,
        ];
    };
};
//# sourceMappingURL=style.js.map